/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Novelist API
 * Admin REST API
 * OpenAPI spec version: 9999eb1d882990f19e352fba26b6c3f62977c8a7
 */

/**
 * When the publisher payout for a rate is due.
 */
export type PaymentMoment = typeof PaymentMoment[keyof typeof PaymentMoment];


export const PaymentMoment = {
  progressive: 'progressive',
  upfront: 'upfront',
} as const;
